module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/2_cf2d440b040c9388ad734c9ce2ae9efb.png";